import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CompanySectorRequest, CompanySectorResponse } from '../models/company-sector.model';

@Injectable({ providedIn: 'root' })
export class CompanySectorApiService {
  private readonly apiUrl = `${environment.apiUrl}api/company-sectors`;

  constructor(private http: HttpClient) {}

  // GET /api/company-sectors - Returns array (not paginated)
  getAll(): Observable<CompanySectorResponse[]> {
    return this.http.get<CompanySectorResponse[]>(this.apiUrl);
  }

  // GET /api/company-sectors/{id}
  getById(id: number): Observable<CompanySectorResponse> {
    return this.http.get<CompanySectorResponse>(`${this.apiUrl}/${id}`);
  }

  // POST /api/company-sectors
  create(sector: CompanySectorRequest): Observable<CompanySectorResponse> {
    return this.http.post<CompanySectorResponse>(this.apiUrl, sector);
  }

  // PUT /api/company-sectors/{id}
  update(id: number, sector: CompanySectorRequest): Observable<CompanySectorResponse> {
    return this.http.put<CompanySectorResponse>(`${this.apiUrl}/${id}`, sector);
  }

  // DELETE /api/company-sectors/{id}
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
